import React, { useEffect, useState } from "react";

import Logo from "../../../assets/images/falcon-horizental.png";
import appStore from "../../../assets/images/app-store-new.svg";
import { colors } from "../../../utils/Colors";
import { Styles } from "./header";

import { CgProfile } from "react-icons/cg";
import { GiHamburgerMenu } from "react-icons/gi";

import { Link, useNavigate } from "react-router-dom";

import { useAuthContext } from "../../../features/authentication";
import MessagesDialogTrigger from "../../../features/quickblox/components/MessageDialog";
import RoutesPath from "../../../utils/Paths";
import Notifications from "../Notifications";
import LogoutButton from "./LogoutButton";
import SweetAlert from "react-bootstrap-sweetalert";
import { useDispatch } from "react-redux";
import { deleteAccount } from "../../../store/thunks/profileThunk";

// Device detection helpers
const isMobile = () => {
  if (typeof navigator === "undefined") return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};
const getMobileOS = () => {
  if (typeof navigator === "undefined") return null;
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  if (/android/i.test(ua)) return "android";
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
  return null;
};
const mobileOS = isMobile() ? getMobileOS() : null;

const Header = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated, logOut } = useAuthContext();
  const [scrolled, setScrolled] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleScroll = () => {
      const isTop = window.scrollY < 10;
      setScrolled(!isTop);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDeleteAccount = () => {
    setIsDelete(true);
  };

  const handleDeleteAccountConfirm = async () => {
    setIsDeleting(true);
    const result = await dispatch(deleteAccount());
    if (result) {
      await logOut();
      navigate("/sign-in");
    }
    setIsDelete(false);
    setIsDeleting(false);
  };

  return (
    <>
      <Styles colors={colors}>
        <nav className={scrolled ? "navbar-shadow" : ""}>
          <div className="header-wrapper d-flex align-items-center justify-content-between w-100">
            <div className="d-flex align-items-center justify-content-between gap-5">
              <Link to="/">
                <img className="falcon-logo" src={Logo} alt="logo" />
              </Link>
              <span className="d-none d-md-block" style={{ color: 'black', fontSize: "20px", fontWeight: 900, whiteSpace: "nowrap", fontFamily: "'Arial Black', 'Arial Bold', Gadget, sans-serif" }}>
                Jobs. Services. Freelancers.
              </span>
            </div>
            {isMobile() && (
              <div className="mobile-store-button">
                {mobileOS === "android" ? (
                  <a
                    href="https://play.google.com/store/apps/details?id=com.gigfalcon"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                      alt="Play Store"
                      style={{ height: "30px" }}
                    />
                  </a>
                ) : mobileOS === "ios" ? (
                  <a
                    href="https://apps.apple.com/us/app/gig-falcon/id6499023603"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                      alt="App Store"
                      style={{ height: "30px" }}
                    />
                  </a>
                ) : null}
              </div>
            )}

            {!isMobile() && (
              <div className="mobile-store-button" style={{ gap: "10px" }}>
                <a
                  href="https://play.google.com/store/apps/details?id=com.gigfalcon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                    alt="Play Store"
                    style={{ height: "30px", width: "100px" }}
                  />
                </a>
                <a
                  style={{ marginLeft: "20px" }}
                  href="https://apps.apple.com/us/app/gig-falcon/id6499023603"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={appStore}
                    alt="App Store"
                    style={{ height: "30px", width: "100px" }}
                  />
                </a>
              </div>
            )}

            <div className="d-flex align-items-center gap-2">
              <div className="menu-options gap-3">
                <Link className="faq-nav-link"
                  style={{ color: 'black', fontSize: "20px", fontWeight: 900, whiteSpace: "nowrap", fontFamily: "'Arial Black', 'Arial Bold', Gadget, sans-serif" }}
                  to={RoutesPath.faq}>
                  FAQ
                </Link>
              </div>
              <div className="d-md-none">
                <Notifications />
              </div>
              {isAuthenticated && (
                <div>
                  <MessagesDialogTrigger />
                </div>
              )}
              <GiHamburgerMenu
                className="hamburger"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasExample"
                aria-controls="offcanvasExample"
              />

              {/* ── Desktop dropdown ─────────────────────────── */}
              <div className="nav-content">
                {isAuthenticated ? (
                  <div className="menu-options">
                    <div className="px-3 d-none d-md-block">
                      <Notifications />
                    </div>
                    <div className="dropdown">
                      <div
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        className="ms-3 pointer-event"
                      >
                        <div className="d-flex gap-2 align-items-center">
                          <div className="user-img">
                            {user?.profileImg?.imgUrl ? (
                              <img src={user.profileImg.imgUrl} alt={"user"} />
                            ) : (
                              <CgProfile
                                className="profile-icon"
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              />
                            )}
                          </div>
                          <div className="text-sm">
                            <p>{user.username}</p>
                            <p className="text-muted text-xs">{user.email}</p>
                          </div>
                        </div>
                      </div>

                      <ul
                        className="dropdown-menu mt-1 pb-3 p-3 home-dropdown"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <div className="d-flex gap-5">
                          {/* Seller section */}
                          {user.role === "seller" && (
                            <div>
                              <h5 className="heading">Seller</h5>
                              <li
                                className="mb-1"
                                onClick={() => navigate("/create-gig")}
                                style={{ cursor: "pointer" }}
                              >
                                <p className="dropdown-item ps-1">
                                  <span>Create a Gig</span>
                                </p>
                              </li>
                              <li
                                className="mb-1"
                                onClick={() => navigate("/manage-gigs")}
                                style={{ cursor: "pointer" }}
                              >
                                <p className="dropdown-item ps-1">
                                  <span>Manage Gigs</span>
                                </p>
                              </li>
                              <li
                                className="mb-1"
                                onClick={() => navigate("/sent-offers")}
                                style={{ cursor: "pointer" }}
                              >
                                <p className="dropdown-item ps-1">
                                  <span>Sent Offers</span>
                                </p>
                              </li>
                              <li
                                className="mb-1"
                                onClick={() => navigate("/seller-orders")}
                                style={{ cursor: "pointer" }}
                              >
                                <p className="dropdown-item ps-1">
                                  <span>Sales Orders</span>
                                </p>
                              </li>
                              <li
                                className="mb-1"
                                style={{ cursor: "pointer" }}
                                onClick={() => navigate("/payments")}
                              >
                                <p className="dropdown-item ps-1">
                                  <span>Payments</span>
                                </p>
                              </li>
                              <li
                                className="mb-1"
                                style={{ cursor: "pointer" }}
                                onClick={() => navigate("/earnings")}
                              >
                                <p className="dropdown-item ps-1">
                                  <span>Earnings</span>
                                </p>
                              </li>
                            </div>
                          )}

                          {/* Employer section */}
                          {user.isEmployer === true && (
                            <div>
                              <h5 className="heading">Employer</h5>
                              <li
                                className="mb-1"
                                onClick={() => navigate("/create-job")}
                                style={{ cursor: "pointer" }}
                              >
                                <p className="dropdown-item ps-1">
                                  <span>Create a Job</span>
                                </p>
                              </li>
                              <li
                                className="mb-1"
                                onClick={() => navigate("/jobs")}
                                style={{ cursor: "pointer" }}
                              >
                                <p className="dropdown-item ps-1">
                                  <span>Manage Jobs</span>
                                </p>
                              </li>
                              <li
                                className="mb-1"
                                onClick={() => navigate("/incoming-candidates")}
                                style={{ cursor: "pointer" }}
                              >
                                <p className="dropdown-item ps-1">
                                  <span>Incoming Candidates</span>
                                </p>
                              </li>
                              <li
                                className="mb-1"
                                onClick={() => navigate(RoutesPath.subscriptionPlans)}
                                style={{ cursor: "pointer" }}
                              >
                                <p className="dropdown-item ps-1">
                                  <span>Subscription</span>
                                </p>
                              </li>
                            </div>
                          )}

                          {/* Buyer section */}
                          <div>
                            <h5 className="heading">Buyer</h5>
                            <li
                              className="mb-1"
                              style={{ cursor: "pointer" }}
                              onClick={() => navigate(RoutesPath.postProject)}
                            >
                              <p className="dropdown-item ps-1">
                                <span>Create a Project</span>
                              </p>
                            </li>
                            <li
                              className="mb-1"
                              style={{ cursor: "pointer" }}
                              onClick={() => navigate(RoutesPath.manageProjects)}
                            >
                              <p className="dropdown-item ps-1">
                                <span>Manage Projects</span>
                              </p>
                            </li>
                            <li
                              className="mb-1"
                              onClick={() => navigate("/incoming-offers")}
                            >
                              <p
                                className="dropdown-item ps-1"
                                style={{ cursor: "pointer" }}
                              >
                                <span>Incoming Offers</span>
                              </p>
                            </li>
                            <li
                              className="mb-1"
                              onClick={() => navigate("/buyer-orders")}
                            >
                              <p
                                className="dropdown-item ps-1"
                                style={{ cursor: "pointer" }}
                              >
                                <span>Purchase Orders</span>
                              </p>
                            </li>
                          </div>

                          {/* General section */}
                          <div>
                            <h5 className="heading">General</h5>
                            <li
                              className="mb-1"
                              onClick={() => navigate(RoutesPath.faq)}
                              style={{ cursor: "pointer" }}
                            >
                              <p className="dropdown-item ps-1">
                                <span>FAQ</span>
                              </p>
                            </li>
                            {user.role === "buyer" && (
                              <li
                                className="mb-1"
                                onClick={() => navigate("/become-seller")}
                                style={{ cursor: "pointer" }}
                              >
                                <p className="dropdown-item ps-1">
                                  <span>Become Seller</span>
                                </p>
                              </li>
                            )}
                            {!user.isEmployer && (
                              <li
                                className="mb-1"
                                onClick={() => navigate("/become-employer")}
                                style={{ cursor: "pointer" }}
                              >
                                <p className="dropdown-item ps-1">
                                  <span>Become an Employer</span>
                                </p>
                              </li>
                            )}
                            <li
                              className="mb-1"
                              onClick={() => navigate("/favourites")}
                              style={{ cursor: "pointer" }}
                            >
                              <p className="dropdown-item ps-1">
                                <span>Favorites</span>
                              </p>
                            </li>
                            <li
                              className="mb-1"
                              onClick={() => navigate("/settings")}
                              style={{ cursor: "pointer" }}
                            >
                              <p className="dropdown-item ps-1">
                                <span>Profile Settings</span>
                              </p>
                            </li>
                            <li
                              className="mb-1"
                              onClick={() => handleDeleteAccount()}
                              style={{ cursor: "pointer" }}
                            >
                              <p className="dropdown-item ps-1">
                                <span>Delete Account</span>
                              </p>
                            </li>
                            <LogoutButton
                              className="dropdown-item ps-1"
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        </div>
                      </ul>
                    </div>
                  </div>
                ) : (
                  <div className="menu-options gap-3">
                    <Link className="post-job-btn" to="/sign-up">
                      <p>Sign Up</p>
                    </Link>
                    <Link className="post-job-btn" to="/sign-in">
                      <p>Sign In</p>
                    </Link>
                  </div>
                )}

              </div>
            </div>

            {/* ── Mobile offcanvas ──────────────────────────── */}
            <div
              className="offcanvas offcanvas-end"
              tabIndex="-1"
              id="offcanvasExample"
              aria-labelledby="offcanvasExampleLabel"
            >
              <div className="offcanvas-header">
                <h5 id="offcanvasExampleLabel" className="falcon-clr">
                  Menu
                </h5>
                <button
                  type="button"
                  className="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div className="offcanvas-body">
                {isAuthenticated ? (
                  <div>
                    <div className="text-md mb-3 d-flex align-items-center gap-3">
                      <div className="mobile-user-img">
                        {user?.profileImg?.imgUrl ? (
                          <img src={user.profileImg.imgUrl} alt={"user"} />
                        ) : (
                          <CgProfile className="profile-icon" />
                        )}
                      </div>
                      <div>
                        <p>{user.username}</p>
                        <p className="text-muted text-sm">{user.email}</p>
                      </div>
                    </div>

                    {/* Buyer */}
                    <div className="mb-4">
                      <h5 className="heading mb-1">Buyer</h5>
                      <p
                        className="regular grey-clr mb-1"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate(RoutesPath.postProject)}
                      >
                        Create a Project
                      </p>
                      <p
                        className="regular grey-clr mb-1"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate(RoutesPath.manageProjects)}
                      >
                        Manage Projects
                      </p>
                      <p
                        className="regular grey-clr mb-1"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/incoming-offers")}
                      >
                        Incoming Offers
                      </p>
                      <p
                        className="regular grey-clr mb-1"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/buyer-orders")}
                      >
                        Purchase Orders
                      </p>
                    </div>

                    {/* Seller */}
                    {user.role === "seller" && (
                      <div className="mb-4">
                        <h5 className="heading mb-2">Seller</h5>
                        <p
                          className="regular grey-clr mb-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/create-gig")}
                        >
                          Create a Gig
                        </p>
                        <p
                          className="regular grey-clr mb-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/seller-orders")}
                        >
                          Sales Orders
                        </p>
                        <p
                          className="regular grey-clr mb-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/manage-gigs")}
                        >
                          Manage Gigs
                        </p>
                        <p
                          className="regular grey-clr mb-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/sent-offers")}
                        >
                          Sent Offers
                        </p>
                        <p
                          className="regular grey-clr mb-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/payments")}
                        >
                          Payments
                        </p>
                        <p
                          className="regular grey-clr mb-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/earnings")}
                        >
                          Earnings
                        </p>
                      </div>
                    )}

                    {/* Employer */}
                    {user.isEmployer === true && (
                      <div className="mb-4">
                        <h5 className="heading mb-2">Employer</h5>
                        <p
                          className="regular grey-clr mb-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/create-job")}
                        >
                          Create a Job
                        </p>
                        <p
                          className="regular grey-clr mb-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/jobs")}
                        >
                          Manage Jobs
                        </p>
                        <p
                          className="regular grey-clr mb-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/incoming-candidates")}
                        >
                          Incoming Candidates
                        </p>
                        <p
                          className="regular grey-clr mb-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate(RoutesPath.subscriptionPlans)}
                        >
                          Subscription
                        </p>
                      </div>
                    )}

                    {/* General */}
                    <div className="mb-4">
                      <h5 className="heading mb-1">General</h5>
                      <p
                        className="regular grey-clr mb-1"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate(RoutesPath.faq)}
                      >
                        FAQ
                      </p>
                      {user.role === "buyer" && (
                        <p
                          className="regular grey-clr mb-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/become-seller")}
                        >
                          Become Seller
                        </p>
                      )}
                      {!user.isEmployer && (
                        <p
                          className="regular grey-clr mb-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/become-employer")}
                        >
                          Become an Employer
                        </p>
                      )}
                      <p
                        className="regular grey-clr mb-1"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/favourites")}
                      >
                        Favorites
                      </p>
                      <p
                        className="regular grey-clr mb-1"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/settings")}
                      >
                        Profile Settings
                      </p>
                      <p
                        className="regular grey-clr mb-1"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDeleteAccount()}
                      >
                        Delete Account
                      </p>
                      <LogoutButton
                        className="regular grey-clr mb-1"
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>
                ) : (
                  <div>
                    <h5
                      className="text-center p-1"
                      onClick={() => navigate("/sign-in")}
                      style={{ cursor: "pointer" }}
                    >
                      Sign In
                    </h5>
                    <hr />
                    <h5
                      className="text-center p-1"
                      onClick={() => navigate("/sign-up")}
                      style={{ cursor: "pointer" }}
                    >
                      Sign Up
                    </h5>
                    <hr />
                    <h5
                      className="text-center p-1"
                      onClick={() => navigate(RoutesPath.faq)}
                      style={{ cursor: "pointer" }}
                    >
                      FAQ
                    </h5>
                    <hr />
                  </div>
                )}
              </div>
            </div>
          </div>
        </nav>


        {isDelete && (
          <SweetAlert
            danger
            title={
              "Are you sure you want to delete your account? You won't be able to recover it and all your data will be lost."
            }
            confirmBtnText={isDeleting ? "Deleting Account..." : "Yes, delete it!"}
            confirmBtnBsStyle="danger"
            showCancel
            focusCancelBtn
            onConfirm={() => handleDeleteAccountConfirm()}
            onCancel={() => setIsDelete(false)}
          />
        )}
      </Styles>
      {isMobile() && (
        <div className="d-flex justify-content-center">
          <span className="d-block d-md-none" style={{ color: 'black', fontSize: "20px", fontWeight: 900, whiteSpace: "nowrap", fontFamily: "'Arial Black', 'Arial Bold', Gadget, sans-serif" }}>
            Jobs. Services. Freelancers.
          </span>
        </div>
      )}
    </>
  );
};

export default Header;